module.exports = __webpack_public_path__ + "img/icon-resize.3f10430e.svg";